var UpdateAppURLHelper, usePushState;

module.exports = UpdateAppURLHelper = function(adjustedURL, opts) {
  var ref;
  if (opts == null) {
    opts = {};
  }
  if (usePushState(opts)) {
    return window.history.pushState(null, null, adjustedURL);
  } else if (((ref = window.history) != null ? ref.replaceState : void 0) != null) {
    return window.history.replaceState(null, null, adjustedURL);
  } else {
    return window.location = adjustedURL;
  }
};

usePushState = function(opts) {
  var ref;
  if (!opts.pushState) {
    return false;
  }
  return ((ref = window.history) != null ? ref.pushState : void 0) != null;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9zaGFyZWQvZnJvbnRlbmQvaGVscGVycy9hcHBfdXJsLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2Fic2hhcm1hL25hcGlzdHJhbm8vYnVpbGQvMTQ4NjY3NTYyNDI3NC03NDM3L3N0YWdpbmctcGVyZi0yMDE3LjAyLjA5XzAwLjM1L2dvb2RzL21vZHVsZXMvc2hhcmVkL2Zyb250ZW5kL2hlbHBlcnMvYXBwX3VybC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxNQUFNLENBQUMsT0FBUCxHQUFpQixrQkFBQSxHQUFxQixTQUFDLFdBQUQsRUFBYyxJQUFkO0FBQ3BDLE1BQUE7O0lBRGtELE9BQUs7O0VBQ3ZELElBQUcsWUFBQSxDQUFhLElBQWIsQ0FBSDtXQUNFLE1BQU0sQ0FBQyxPQUFPLENBQUMsU0FBZixDQUF5QixJQUF6QixFQUErQixJQUEvQixFQUFxQyxXQUFyQyxFQURGO0dBQUEsTUFFSyxJQUFHLG9FQUFIO1dBQ0gsTUFBTSxDQUFDLE9BQU8sQ0FBQyxZQUFmLENBQTRCLElBQTVCLEVBQWtDLElBQWxDLEVBQXdDLFdBQXhDLEVBREc7R0FBQSxNQUFBO1dBR0gsTUFBTSxDQUFDLFFBQVAsR0FBa0IsWUFIZjs7QUFIK0I7O0FBUXRDLFlBQUEsR0FBZSxTQUFDLElBQUQ7QUFDYixNQUFBO0VBQUEsSUFBQSxDQUFvQixJQUFJLENBQUMsU0FBekI7QUFBQSxXQUFPLE1BQVA7O1NBQ0E7QUFGYSJ9
